import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
// import { log } from 'console';
import { ToastrService } from 'ngx-toastr';
import { catchError, map, throwError } from 'rxjs';
import { BaseService } from 'src/app/helpers/base.service';
import { DataService } from 'src/app/helpers/data.service';
import { iEmpStationsResult } from 'src/app/helpers/Interfaces/emp-stations';
import {
  UserSettings,
  UserSettingsDto,
} from 'src/app/helpers/Interfaces/user-settings';
import { iUser } from 'src/app/helpers/Interfaces/users';
import { environment } from 'src/environments/environment.development';

@Injectable({
  providedIn: 'root',
})
export class AuthService extends BaseService {
  private _login = `${environment.base_url}/api/User/Login`;
  private _getRoleByName = `${environment.base_url}/api/Role/GetByName`;
  private _addUser = `${environment.base_url}/api/User/Add`;
  private _getById = `${environment.base_url}/api/User/GetById`;
  private _addUserAnno = `${environment.base_url}/api/User/AddUser`;
  private _updateUser = `${environment.base_url}/api/User/Update`;
  private _forgotPassword = `${environment.base_url}/api/User/ForgotPassword`;
  private _resetPassword = `${environment.base_url}/api/User/ResetPassword`;
  private _permanentDelete = `${environment.base_url}/api/User/PermanentDelete`;
  private _addOrUpdate = `${environment.base_url}/api/User/AddOrUpdate`;
  private _changePwd = `${environment.base_url}/api/User/ChangePwd`;

  // User Settings
  private readonly _getSettingsByUserId = `${environment.base_url}/api/UserSettings/GetByUserId`;
  private readonly _addSettings = `${environment.base_url}/api/UserSettings/Add`;
  private readonly _updateSettings = `${environment.base_url}/api/UserSettings/Update`;

  constructor(private _router: Router, private _toastrServ: ToastrService) {
    super();
  }

  Login(payload: any) {
    return this._http
      .post<{ token: string; user: any; stations: iEmpStationsResult[] }>(
        this._login,
        {
          ...payload,
          currentDomain: !environment.production
            ? 'localhost'
            : window.location.hostname,
        },
        {
          responseType: 'json',
          withCredentials: true,
        }
      )
      .pipe(
        map((res) => {
          this._dataServ.setToken(res.token);
          this._dataServ.setUser(res.user);
          // if (!this._dataServ.hasPermission('company', ''))
          // if (res?.stations?.length >= 1) {
          //   this._dataServ.setStationId(res.stations[0]?.stationId as string);
          // }

          return res;
        }),
        catchError((error) => {
          throw error.error;
        })
      );
  }
  Logout() {
    const userId = this._dataServ.userValue?.id;
    let logoutUrl = `${environment.authUrl}/logout`;
    if (userId)
      logoutUrl += this.serializeData({
        id: userId,
        token: this._dataServ.tokenValue,
      });
    this._dataServ.clear();
    window.location.replace(logoutUrl);
  }
  private createFormDataPayload(data: any): FormData {
    const payload = new FormData();
    payload.set('Name', data.name);
    payload.set('Phone', data.phone);
    payload.set('Password', data.password);
    payload.set('Email', data.email);
    payload.set('RoleId', data.roleId);
    if (data.username) payload.set('Username', data.username);
    if (data.stationId) payload.set('StationId', data.stationId);
    if (data.workspaceId) payload.set('WorkspaceId', data.workspaceId);
    if (data.isStartup) payload.set('IsStartup', data.isStartup);
    return payload;
  }
  getUserById(Id: string, token: string) {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', `Bearer ${token}`);
    return this._http.get<iUser>(this._getById, {
      responseType: 'json',
      params: { Id },
      headers,
    });
  }
  AddUser(data: any) {
    const payload = this.createFormDataPayload(data);
    let headers = new HttpHeaders();
    return this._http.post<any>(this._addUser, payload, {
      responseType: 'json',
      headers,
    });
  }
  AddUserAnno(data: any) {
    const workspaceId = data.workspaceId;
    let headers = new HttpHeaders().set('workspaceId', workspaceId);
    return this._http.post<any>(this._addUserAnno, data, {
      responseType: 'json',
      headers,
    });
  }
  AddOrUpdate(payload: any[]) {
    return this._http.post<any>(this._addOrUpdate, payload, {
      responseType: 'json',
    });
  }

  UpdateUser(data: any) {
    const payload = this.createFormDataPayload(data);
    payload.set('Id', data.userId);
    return this._http.put<any>(this._updateUser, payload, {
      responseType: 'json',
    });
  }
  refreshToken() {
    const refreshToken = this._dataServ.refreshTokenValue;
    if (!refreshToken) return throwError(() => new Error('No refresh token'));

    return this._http
      .patch<{
        accessToken: string;
        refreshToken: string;
      }>(`${environment.base_url}/api/User/refresh-token`, null, {
        responseType: 'json',
        params: { refreshToken },
      })
      .pipe(map((response) => response.accessToken));
  }
  GetRoleByName(name: string) {
    return this._http.get<any>(`${this._getRoleByName}?name=${name}`, {
      responseType: 'json',
    });
  }

  GetSettingsByUserId() {
    this._http
      .get(
        `${this._getSettingsByUserId}?userId=${this._dataServ.userValue?.id}`
      )
      .subscribe({
        next: (res: UserSettings) => {
          const dto: UserSettingsDto = {
            ...res,
            dashboards: res?.dashboards
              ? JSON.parse(res.dashboards)
              : undefined,
            dashboard: res?.dashboard ? JSON.parse(res.dashboard) : undefined,
          };
          this._dataServ.setUserSettings(dto);
        },
        error: (er) => {
          this._toastrServ.error(
            'Something went wrong while fetching user settings.'
          );
          console.warn(er);
        },
      });
  }
  AddUserSettings(payload: UserSettings) {
    return this._http
      .post<UserSettings>(this._addSettings, payload, {
        responseType: 'json',
      })
      .pipe(
        map((res) => {
          const dto: UserSettingsDto = {
            ...res,
            dashboards: res?.dashboards
              ? JSON.parse(res.dashboards)
              : undefined,
            dashboard: res?.dashboard ? JSON.parse(res.dashboard) : undefined,
          };
          this._dataServ.setUserSettings(dto);
          return res;
        })
      );
  }
  UpdateUserSettings(payload: UserSettings) {
    return this._http
      .put<UserSettings>(this._updateSettings, payload, {
        responseType: 'json',
      })
      .pipe(
        map((res) => {
          const dto: UserSettingsDto = {
            ...res,
            dashboards: res?.dashboards
              ? JSON.parse(res.dashboards)
              : undefined,
            dashboard: res?.dashboard ? JSON.parse(res.dashboard) : undefined,
          };
          this._dataServ.setUserSettings(dto);

          return res;
        })
      );
  }
  ForgotPassword(email: string) {
    return this._http.post(
      `${this._forgotPassword}?UserEmail=${email}`,
      {},
      { responseType: 'json' }
    );
  }
  ResetPassword(payload: { newPassword: string; token: string }) {
    return this._http.post(`${this._resetPassword}`, payload, {
      responseType: 'json',
    });
  }
  permanentDelete(id: string) {
    return this._http.delete(`${this._permanentDelete}?Id=${id}`);
  }
  changePwd(payload: { userId: string; newPassword: string }) {
    return this._http.post(this._changePwd, payload, { responseType: 'json' });
  }
}
